import { Box, Chip } from '@mui/material';
import { GridColDef, GridRenderCellParams } from '@mui/x-data-grid-premium';
import { Flow } from '../../services/flows.service';
import ActivityCell from '../../components/ActivityCell';
import TagChips from '../../components/TagChips';

type AdAccountLite = { id: string; name: string; fb_account_id?: string | null };

export function flowsColumns(opts: {
  includeTrafficSource?: boolean;
  adAccounts?: AdAccountLite[];
  actions: GridColDef<Flow>;
}): GridColDef<Flow>[] {
  return [
    { field: 'ref', headerName: 'Ref', width: 90, sortable: false, valueGetter: (_v, row) => row.ref || '—' },
    { field: 'name', headerName: 'Flow', flex: 1, minWidth: 180 },
    ...(opts.includeTrafficSource
      ? [{ field: 'traffic_source', headerName: 'Traffic Source', width: 160, valueGetter: (_v, row) => row.traffic_source?.name || '-' } as GridColDef<Flow>]
      : []),
    {
      field: '_activity', headerName: 'Activity', width: 150, filterable: false,
      description: 'Non-bot visits in the last hour and the last 24 hours. Sorts by the last 24 hours.',
      renderCell: (p: GridRenderCellParams) => (
        <ActivityCell
          activity={p.row.activity_status} senderLabel="Traffic sources sending to it"
          kind="flow" entityId={p.row.id} updatedAt={p.row.activity_updated_at}
        />
      ),
    },
    { field: 'traffic_cap_limit', headerName: 'Cap', width: 70, type: 'number', editable: true, valueFormatter: (v) => Number(v) > 0 ? String(v) : '-' },
    { field: 'status', headerName: 'Status', width: 100, renderCell: (p: GridRenderCellParams) => (
      <Box sx={{ display: 'flex', alignItems: 'center', height: '100%' }}><Chip label={p.value} size="small" color={p.value === 'active' ? 'success' : 'default'} /></Box>
    )},
    {
      field: 'ad_account_id', headerName: 'Ad Account', width: 150, sortable: false,
      valueGetter: (v) => {
        if (!v) return '';
        const a = (opts.adAccounts || []).find((x) => x.id === v);
        return a ? (a.fb_account_id || a.name) : '';
      },
      valueFormatter: (v) => v || '-',
    },
    { field: 'tag_ids', headerName: 'Tags', flex: 1, minWidth: 150, sortable: false, renderCell: (p: GridRenderCellParams) => <TagChips ids={p.value ?? []} /> },
    { field: 'created_at', headerName: 'Created', width: 110, valueFormatter: (v) => new Date(v).toLocaleDateString() },
    opts.actions,
  ];
}
